import { Spinner, Tree } from '@fluentui/react-components';
import { useQuery } from '@tanstack/react-query';
import { getApiGraphFoldersOptions } from '../../api/@tanstack/react-query.gen';
import { MailFolderItem } from './MailFolderItem';

export interface IMailFoldersProps {
  onSelectedFolder: (folder: string) => void;
  selectedFolderId: string | null | undefined;
}

export default function MailFolderTree({ onSelectedFolder, selectedFolderId: selectedFolderId }: IMailFoldersProps) {
  const { data: mailFolders, isLoading } = useQuery({
    ...getApiGraphFoldersOptions(),
  });

  return (
    <>
      {isLoading ? <Spinner /> : null}
      <Tree aria-label="mailFolderTree">
        {mailFolders?.map((e) => (
          <MailFolderItem key={e.graphFolderId} folder={e} onSelectedFolder={onSelectedFolder} selectedFolderId={selectedFolderId} />
        ))}
      </Tree>
    </>
  );
}
